import React from 'react'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'
import { useTheme } from '@mui/system'
import { Button } from '@mui/material'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { E3AI360 } from '@e3dc-react/icons'
import { Banner } from 'src/Components/banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import { useTypedSelector } from 'src/State/RootReducer'
import ai360BannerBg from '../assets/banner-background.png'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    [theme.breakpoints.up('xl')]: {
      /* For xl screens */
      background: `url(${ai360BannerBg}) black 370.671px -518.207px / 61.397% 1826.243% no-repeat`,
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      /* For lg screens */
      background: `url(${ai360BannerBg}) black 233.219px -436.713px / 66.73% 1557.029% no-repeat`,
    },
    [theme.breakpoints.between('md', 'lg')]: {
      /* For md screens */
      background: `url(${ai360BannerBg}) black 180.059px -339.649px / 67.271% 1233.309% no-repeat`,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      /* For sm screens */
      background: `url(${ai360BannerBg}) black 92.164px -167.616px / 69.25% 512.963% no-repeat`,
    },
    [theme.breakpoints.down('sm')]: {
      /* For xs screens (mobile) */
      background: `url(${ai360BannerBg}) black 27.534px -92.687px / 84.174% 189.392% no-repeat`,
    },
  },
  textStyle: {
    color: theme.palette.common.white,
  },
  closeActionStyle: {
    color: theme.palette.common.white,
  },
}))

const AI360ReleaseBanner: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()
  const activeInstallation = useTypedSelector(state => state.storage.installation)
  const storageId = useTypedSelector(state => state.storage.activeStorage)

  const handleClick = (): void => {
    navigate(`/dashboard/ai360/${activeInstallation?.id}/${storageId}`)
  }

  return (
    <Banner
      icon={<E3AI360 sx={{ color: theme.palette.primary.main, width: 30, height: 30 }} />}
      i18nKey="ai360.banners.ai360-release"
      bannerKey={BannerKey.AI360ReleaseBanner}
      closeType={BannerCloseTypes.permanentOrTemporary}
      containerStyle={classes.containerStyle}
      textStyle={classes.textStyle}
      closeActionStyle={classes.closeActionStyle}
      button={
        <Button variant="contained" onClick={handleClick}>
          {t('common.activate')}
        </Button>
      }
    />
  )
}

export default AI360ReleaseBanner
